var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DateCalendar from "@frameworks/salesjourney/components/Generic/DateCalendar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { EDataSource, EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { futureMonth, getDateInFormat, getFinancialYear, getLocalISOString, TodaysDate, } from "@domains/utils/reportDates";
import moment from "moment";
import FilterState from "@frameworks/salesjourney/components/Home/filterState";
import EdModal from "@frameworks/shared-library/components/edModal";
import UploadPortfolio from "./UploadPortfolio";
import advisoryDI from "@frameworks/salesjourney/components/Features/Advisory/di/servicelocator";
import filterDi from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import CASUploadTable from "./CASUploadTable";
import { getQueryParameterName } from "@frameworks/salesjourney/utils/genericMethods";
import { EnumFileStatus } from "./constant";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { useSelector } from "react-redux";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
// import SearchField1 from "components/Generic/Search/SearchField1";
import SearchClientPartner from "@frameworks/salesjourney/components/Generic/Search/SearchClientPartner";
import SalesRating from "@frameworks/salesjourney/components/Generic/SalesRating";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var filterList = [
    {
        filter: "Lob",
        dataSource: EDataSource.LOB,
        value: EnumSalesFilter.lobId,
        inputType: "checkbox",
        //   onClick: onclick("lobId"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.lobIdLst,
        dropDownList: [],
    },
    {
        filter: "Sub Lob",
        dataSource: EDataSource.SUBLOB,
        value: EnumSalesFilter.sublobId,
        inputType: "checkbox",
        //   onClick: onclick("subLobId"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.sublobIdLst,
        dropDownList: [],
    },
    {
        filter: "Zone",
        dataSource: EDataSource.ZONE,
        value: EnumSalesFilter.zoneId,
        inputType: "checkbox",
        //   onClick: onclick("Zone"),
        //   disabled: false,
        alternateValue: EnumSalesFilter.zoneIdLst,
        dropDownList: [],
    },
    {
        filter: "Region",
        dataSource: EDataSource.REGION,
        value: EnumSalesFilter.regionId,
        inputType: "checkbox",
        //   onClick: onclick("Region"),
        //   disabled: false,
        alternateValue: EnumSalesFilter.regionIdLst,
        dropDownList: [],
    },
    {
        filter: "Branch",
        dataSource: EDataSource.BRANCH,
        value: EnumSalesFilter.branchId,
        inputType: "checkbox",
        //   onClick: onclick("Branch"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.branchIdLst,
        dropDownList: [],
    },
    {
        filter: "RM",
        dataSource: EDataSource.RM,
        value: EnumSalesFilter.rmId,
        inputType: "checkbox",
        searchBox: true,
        searchValue: "",
        alternateValue: EnumSalesFilter.rmIdLst,
        dropDownList: [],
    },
    {
        filter: "Type",
        dataSource: EDataSource.TYPE,
        value: EnumSalesFilter.teamType,
        alternateValue: EnumSalesFilter.teamTypeLst,
        inputType: "checkbox",
        //   onClick: onclick(""),
        //   disabled: true,
        dropDownList: [],
    },
    // {
    //   filter: "Cust Type",
    //   // dataSource: EDataSource.TIER,
    //   value: EnumSalesFilter.custType,
    //   inputType: "checkbox",
    //   //   disabled: false,
    //   alternateValue: EnumSalesFilter.custTypeLst,
    //   dropDownList: [] as IFilterlist[],
    // },
];
var AdvisoryDashboard = function () {
    var _a, _b, _c, _d;
    var isRHAbove = localStorage.getItem(ELocalStorageKeys.IsRHAbove);
    var encodedFilterData = getQueryParameterName("filterData");
    var _e = __read(React.useState(filterList), 2), localFilterList = _e[0], setLocalFilterList = _e[1];
    var getDefaultFilters = function () {
        if (!!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y") {
            return {
                teamType: [1, 2],
                teamTypeLst: [
                    {
                        id: leadStatusConfig.selfTeamObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.selfTeamObject.name,
                    },
                    {
                        id: leadStatusConfig.teamTypeObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.teamTypeObject.name,
                    },
                ],
                dataSource: EDataSource.TYPE,
            };
        }
        else {
            return {
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().toDate(), "YYYY/MM/DD"),
                teamType: [1],
            };
        }
    };
    var retainedFilterData = useSelector(function (state) { return state.Common.filterDataReducer.finalFilterState; });
    var location = useLocation();
    var resetfilter = (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.reset) !== null && _b !== void 0 ? _b : null;
    var _f = __read(useState(retainedFilterData &&
        Object.keys(retainedFilterData).length > 0 &&
        !resetfilter
        ? retainedFilterData
        : getDefaultFilters()), 2), finalFilterState = _f[0], setFinalFilterState = _f[1];
    var _g = __read(useState(""), 2), clientSearchKey = _g[0], setClientSearchKey = _g[1];
    var _h = __read(useState(true), 2), showCalender = _h[0], setShowCalender = _h[1];
    var _j = __read(React.useState(false), 2), fileUploading = _j[0], setFileUploading = _j[1];
    var _k = __read(useState(null), 2), casUploadHistoryTableData = _k[0], setCasUploadHistoryTableData = _k[1];
    var _l = __read(useState(null), 2), casUploadSummaryData = _l[0], setCasUploadSummaryData = _l[1];
    var _m = __read(useState(false), 2), casTableLoader = _m[0], setCASTableLoader = _m[1];
    var _o = __read(useState(false), 2), summaryLoader = _o[0], setSummaryLoader = _o[1];
    var navigate = useNavigate();
    var _p = __read(useState(false), 2), showModal = _p[0], setShowModal = _p[1];
    var _q = __read(React.useState(false), 2), showPortfolioModal = _q[0], setShowPortfolioModal = _q[1];
    var _r = __read(React.useState(true), 2), showMonth = _r[0], setShowMonth = _r[1];
    var _s = __read(React.useState(false), 2), resetShowMonth = _s[0], setResetShowMonth = _s[1];
    var _t = __read(useState({
        fromDate: "",
        toDate: "",
    }), 2), dateRange = _t[0], setDateRange = _t[1];
    var _u = __read(useState(false), 2), showAdvisoryRating = _u[0], setShowAdvisoryRating = _u[1];
    var dateChangeFilterData = function (startDate, endDate, showMonth, showWeek) {
        if (showMonth === void 0) { showMonth = false; }
        if (showWeek === void 0) { showWeek = false; }
        setFinalFilterState(function (prevFinalFilterState) {
            var dateRange = {
                fromDate: moment(startDate).format("YYYY/MM/DD"),
                toDate: moment(endDate).format("YYYY/MM/DD"),
            };
            setDateRange(dateRange);
            var filterstate = __assign(__assign(__assign({}, prevFinalFilterState), dateRange), { showMonth: showMonth, showWeek: showWeek });
            filterDi.filter.updateFinalFilterState(filterstate);
            return filterstate;
        });
    };
    var getFilterDataApis = function (filterName) {
        if (filterName === EnumSalesFilter.custType) {
            return filterDi.filter.getFilterCustomerType({
                page: "1",
                pageSize: "100",
            });
        }
    };
    var getAdvisoryRatingData = function (code) {
        profileDI.profile
            .getValidateFeedbackData({ submoduleCode: code })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.showFeedbackPopup) {
                setShowAdvisoryRating(true);
            }
            else {
                setShowAdvisoryRating(false);
            }
        })
            .catch(function (err) {
            setShowAdvisoryRating(false);
        });
    };
    useEffect(function () {
        if (!fileUploading) {
            getCASUploadHistory(finalFilterState);
        }
    }, [dateRange, fileUploading, encodedFilterData]);
    useEffect(function () {
        if (!fileUploading)
            getCASUploadSummary();
    }, [fileUploading]);
    var getCASUploadSummary = function () {
        setSummaryLoader(true);
        advisoryDI.advisory
            .getCasUploadSummary()
            .then(function (result) {
            var _a, _b, _c;
            setSummaryLoader(false);
            setCasUploadSummaryData(result.data);
            if (((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.completed) > 0 ||
                ((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.error) > 0 ||
                ((_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.inprocess) > 0) {
                getAdvisoryRatingData(3);
            }
        })
            .catch(function (error) {
            setSummaryLoader(false);
            console.log(error);
        });
    };
    var getCASUploadHistory = function (filterData, pageNumber, clientSeachKey) {
        if (pageNumber === void 0) { pageNumber = 1; }
        return __awaiter(void 0, void 0, void 0, function () {
            var filterDataComingfromParams, casUploadHistoryPayload;
            return __generator(this, function (_a) {
                if (encodedFilterData) {
                    filterDataComingfromParams = JSON.parse(encodedFilterData);
                    filterData = filterDataComingfromParams;
                    if (filterDataComingfromParams === null || filterDataComingfromParams === void 0 ? void 0 : filterDataComingfromParams.filestatus) {
                        setFinalFilterState({});
                        setShowCalender(false);
                        setLocalFilterList(function (localFilterList) {
                            localFilterList = localFilterList.map(function (x) {
                                x.dropDownList = [];
                                return x;
                            });
                            return localFilterList;
                        });
                    }
                }
                if (clientSeachKey || clientSearchKey) {
                    filterData = __assign(__assign({}, filterData), { clientSeachKey: clientSeachKey !== null && clientSeachKey !== void 0 ? clientSeachKey : clientSearchKey });
                }
                casUploadHistoryPayload = {
                    filterdata: __assign({}, filterData),
                    page: pageNumber,
                    pageSize: 10,
                };
                setCASTableLoader(true);
                advisoryDI.advisory
                    .getCASUploadHistory(__assign({}, casUploadHistoryPayload))
                    .then(function (casUploadHistory) {
                    setCASTableLoader(false);
                    setCasUploadHistoryTableData(casUploadHistory);
                })
                    .catch(function (error) {
                    setCASTableLoader(false);
                });
                return [2 /*return*/];
            });
        });
    };
    var onSubmit = function () {
        setResetShowMonth(false);
        filterDi.filter.updateFinalFilterState(finalFilterState);
        getCASUploadHistory(finalFilterState, 1);
    };
    var resetFunction = function () {
        setLocalFilterList(function (localFilterList) {
            localFilterList = localFilterList.map(function (x) {
                x.dropDownList = [];
                return x;
            });
            return localFilterList;
        });
        var localFinalFilterState = getDefaultFilters();
        filterDi.filter.updateFinalFilterState(localFinalFilterState);
        setResetShowMonth(true);
        if (clientSearchKey) {
            setClientSearchKey("");
        }
        if (encodedFilterData) {
            navigate("/dashboard/advisory-dashboard", { replace: true });
            encodedFilterData = "";
            setShowCalender(true);
        }
        getCASUploadHistory(localFinalFilterState, 1, "");
        setFinalFilterState(localFinalFilterState);
    };
    var generateUrl = function (fileStatus) {
        //
        var filterData = {
            filestatus: fileStatus,
        };
        return ("/dashboard/advisory-dashboard/?filterData=" +
            encodeURI(JSON.stringify(filterData)));
    };
    React.useEffect(function () {
        return function () {
            filterList = filterList.map(function (x) {
                return __assign(__assign({}, x), { dropDownList: [] });
            });
        };
    }, []);
    var handleSubmitDashboardFeedback = function (ratingFlag, selectedStars, commentText) {
        profileDI.profile.saveDashboardFeedback({
            submodule_code: 3,
            rating_date: getLocalISOString(new Date()),
            rating_flg: ratingFlag,
            rating: selectedStars ? selectedStars : 0,
            remarks: commentText ? commentText : "",
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { parentClass: "advisory-dashboard-primary-conatiner" },
            React.createElement("div", { className: "summary-title-conatiner" },
                React.createElement("span", { className: "title DMSanBold_18_700 txt_blackOne1 col" }, "Lifetime CAS Upload Summary"),
                React.createElement(SearchClientPartner, { setSearchText: function (str) {
                        //str=panno
                        // let filterdata: ISalesFilterReqParam = {
                        //   ...finalFilterState,
                        //   clientSeachKey: str,
                        // };
                        // setFinalFilterState(filterdata);
                        setClientSearchKey(str);
                        getCASUploadHistory(finalFilterState, 1, str);
                    }, clearSearch: !clientSearchKey })),
            React.createElement("div", { className: "all-summary-container d-flex align-items-center" },
                React.createElement("div", { className: "one-summary " },
                    React.createElement("span", { className: "DMSans_16_500 txt-midnight-blue" }, "Complete"),
                    summaryLoader ? (React.createElement("img", { src: loaderGIF })) : (React.createElement(Link, { to: generateUrl(EnumFileStatus.SUCCESS), className: "DMSansM_24_500 txt-midnight-blue text-decoration-underline" }, casUploadSummaryData === null || casUploadSummaryData === void 0 ? void 0 : casUploadSummaryData.completed))),
                React.createElement("div", { className: "one-summary" },
                    React.createElement("span", { className: "DMSans_16_500 txt-midnight-blue" }, "In Process"),
                    summaryLoader ? (React.createElement("img", { src: loaderGIF })) : (React.createElement(Link, { to: generateUrl(EnumFileStatus.INPROCESS), className: " DMSansM_24_500 txt-midnight-blue text-decoration-underline" }, casUploadSummaryData === null || casUploadSummaryData === void 0 ? void 0 : casUploadSummaryData.inprocess))),
                React.createElement("div", { className: "one-summary" },
                    React.createElement("span", { className: "DMSans_16_500 txt-midnight-blue" }, "Error"),
                    summaryLoader ? (React.createElement("img", { src: loaderGIF })) : (React.createElement(Link, { to: generateUrl(EnumFileStatus.FAILED), className: "DMSansM_24_500 txt-midnight-blue text-decoration-underline" }, casUploadSummaryData === null || casUploadSummaryData === void 0 ? void 0 : casUploadSummaryData.error)))),
            React.createElement("div", { className: "calender-upload-portfolio d-flex" },
                React.createElement("div", { className: "calender" }, showCalender ? (React.createElement(DateCalendar, { setFinalFilterState: setFinalFilterState, monthlyFirst: Boolean((_c = retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.showMonth) !== null && _c !== void 0 ? _c : true), weeklyFirst: Boolean((_d = retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.showWeek) !== null && _d !== void 0 ? _d : false), resetShowMonth: resetShowMonth, todaysDate: true, setShowMonthFlag: setShowMonth, fromDate: (retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.fromDate)
                        ? retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.fromDate
                        : moment().startOf("month").format("YYYY-MM-DD"), toDate: (retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.toDate)
                        ? retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.toDate
                        : moment().endOf("month").format("YYYY-MM-DD"), ToDatemax: futureMonth(TodaysDate, 6), isMinDate: true, lastQuarter: true, lastQuarterYear: getFinancialYear(new Date()) - 1, dateChangeFilterData: dateChangeFilterData, skipForFinalYear: true, setEndOfMonth: true })) : (React.createElement("div", { className: "dummy-div" }))),
                React.createElement("div", { className: "upload-portfolio" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", disabled: false, value: React.createElement("div", { className: "d-flex justify-content-center align-items-center" },
                            React.createElement("span", { className: "px-2 EncodeSans_12_500" }, "Sync Nuvama Portfolio")), className: "p-2 btn", onClick: function () {
                            setShowPortfolioModal(true);
                        } }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue", disabled: fileUploading, value: React.createElement("div", { className: "d-flex justify-content-center align-items-center" },
                            React.createElement("span", { className: "px-2 EncodeSans_12_500" }, fileUploading ? "uploading..." : " Upload CAS")), className: "p-2 btn mgl-5", onClick: function () {
                            setShowModal(true);
                        } }),
                    showPortfolioModal && (React.createElement(EdModal, { title: "Sync Portfolio", show: showPortfolioModal, setShow: setShowPortfolioModal, modalTitle: "", showFooter: false, 
                        // closeDropdown={setShowModal}
                        closeOnOutsideClick: true, children: React.createElement(UploadPortfolio, { fileUploading: fileUploading, setFileUploading: setFileUploading, setShowPortfolioModal: setShowPortfolioModal, isPortfolioModal: true, finalFilterState: finalFilterState, getCASUploadHistory: getCASUploadHistory }) })),
                    showModal && (React.createElement(EdModal, { title: "Upload CAS File", show: showModal, setShow: fileUploading ? function () { } : setShowModal, modalTitle: "", showFooter: false, 
                        // closeDropdown={setShowModal}
                        closeOnOutsideClick: true, children: React.createElement(UploadPortfolio, { fileUploading: fileUploading, setFileUploading: setFileUploading, setShowModal: setShowModal, isPortfolioModal: false }) })))),
            React.createElement("div", { className: "filter-section" },
                React.createElement(FilterState, { isSearch: false, finalFilterState: finalFilterState, setFinalFilterState: setFinalFilterState, onSubmit: onSubmit, filterList: localFilterList, showReset: true, resetFunction: resetFunction, getFilterDataApis: getFilterDataApis })),
            React.createElement("div", { className: "cas-table-section" },
                React.createElement(CASUploadTable, { casUploadHistoryTableData: casUploadHistoryTableData, setCasUploadHistoryTableData: setCasUploadHistoryTableData, tableLoader: casTableLoader, getCASUploadHistory: function (pageNumber) {
                        return getCASUploadHistory(finalFilterState, pageNumber);
                    } }))),
        React.createElement("div", { className: "rating-modal" },
            React.createElement(EdModal, { show: showAdvisoryRating, setShow: function () {
                    setShowAdvisoryRating(false);
                    handleSubmitDashboardFeedback(false);
                }, showFooter: false, title: "Rate Us", children: React.createElement(SalesRating, { setShowSalesRating: setShowAdvisoryRating, ratingText: "How would you like to rate us on the lead journey?", onSubmit: handleSubmitDashboardFeedback }), modalTitle: "", size: "modal-dialog-centered", hideCloseBtn: true }))));
};
export default AdvisoryDashboard;
